module.exports = __webpack_public_path__ + "static/media/piaz.098633e9.png";